<template>
  <div class="loading-container">
    <div v-if="isFetching" class="loading-overlay">
      <div class="loader"></div>
    </div>
    <span v-else v-show="isShowPage">
      <span class="page-sub-title">Rekap Integrasi SPKLU</span>
      <v-row>
        <v-col>
          <v-data-table :headers="headersSPKLU" :items="itemsRekap" :items-per-page="itemsPerPage" class="datatable"
            hide-default-footer :page.sync="pageRekap" @page-count="pageRekapCount = $event">
          </v-data-table>
          <v-row>
            <v-col class="mt-5" cols="6">
              Menampilkan
              <v-select v-model="itemsPerPage" :items="[5, 10, 20, 30, 50]" dense solo flat
                class="ml-1 mr-1 size-select" @change="
                  itemsPerPage = parseInt($event, 10);
                page = 1;
                "></v-select>
              data dari <b>{{ itemsRekap.length }}</b>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right mt-5" cols="6">
              <v-pagination v-model="pageRekap" :length="pageRekapCount" :total-visible="5"></v-pagination>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr v-if="showMap" class="line-separator" />
      <span class="page-sub-title">{{ table_title }}</span>
      <v-row align="center" justify="center" class="mt-1">
        <v-col cols="3">
          <v-text-field append-icon="mdi-magnify" outlined solo hide-details v-model="search" class="search"
            placeholder="Search..." color="#2671D9">
          </v-text-field>
        </v-col>
        <v-btn class="ma-2" depressed outlined :color="colorActive" @click="openDialogFilter()">
          <v-icon left :color="colorActive"> $ic-filter </v-icon>
          Filter
        </v-btn>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn class="ma-2" depressed outlined color="#2671D9" @click="downloadExcel()">
            <v-icon left color="#2671D9"> $ic-export-excel </v-icon>
            Export Excel
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pt-5">
          <v-data-table :headers="headers" :items="items" class="datatable" :search="search" hide-default-footer
            disable-sort :items-per-page="itemsPerPageDetail" :page.sync="pagination.currentPage"
            :page-count="pagination.totalPages" :loading="isLoading">
            <template v-slot:item.jml_transaksi="{ item }">
              {{ formatCurrency(item.jml_transaksi).split(",")[0] }}
            </template>
          </v-data-table>
          <template>
            <v-container>
              <v-row>
                <v-col cols="4" class="mt-6">
                  <v-row>
                    <v-card class="d-flex mb-6" color="white" flat tile elevation="0">
                      <span class="mt-5 pa-2">Item Per Page</span>
                      <v-select color="accent" :items="[5, 10, 15, 20]" v-model="itemsPerPageDetail" class="my-4" dense
                        solo flat item-color="accent" style="max-width: 100px"></v-select>
                      <span class="mt-5 pa-2"> of {{ pagination.totalElements }}
                        Items</span>
                    </v-card>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3">
                  <v-container class="max-width">
                    <v-pagination v-model="pagination.currentPage" class="my-4" :length="pagination.totalPages"
                      @input="fetchPage()" @next="goToNext()" @previous="goToPrev()" :total-visible="3"></v-pagination>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>{{ dialogTitle }}</span>
              </v-col>
              <v-col cols="1" class="text-right">
                <v-btn icon x-small @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <v-list>
                    <template v-for="(item, index) in chargeBoxList">
                      <v-list-item :key="index">
                        <v-icon v-if="item.isActive" class="mr-5">$ic-spklu-blue</v-icon>
                        <v-icon v-else class="mr-5">$ic-spklu-red</v-icon>
                        <v-list-item-content>
                          <v-list-item-title v-html="item.namaChargebox"></v-list-item-title>
                          <v-list-item-subtitle v-html="item.dayaChargebox"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                              </v-btn>
                            </template>
                            <span v-for="(connector, j) in item.connectors" :key="connector.j">
                              <table>
                                <tr>
                                  <td>{{ "(" + parseInt(j + 1) + ")" }}</td>
                                  <td>Nama Connector</td>
                                  <td>: {{ connector.namaKonektor }}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Status Connector</td>
                                  <td>
                                    :
                                    <span>{{
                                      enumToStatus(connector?.status)
                                    }}</span>
                                  </td>
                                </tr>
                              </table>
                            </span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small depressed :color="colorActive" dark @click="dialog = false">
              Kembali
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFilter" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>Filter Data</span>
              </v-col>
              <v-col class="text-right">
                <v-btn icon x-small @click="dialogFilter = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field style="padding: 0 !important" append-icon="mdi-chevron-down"
                        prepend-icon="mdi-calendar" label="Tanggal" readonly :value="dateDisp" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="searchDate" no-title :allowed-dates="allowedDates" range locale="id-ID"
                      :min="searchDate[0] ? searchDate[0] : ''"></v-date-picker>
                    <v-btn block @click="dateMenu = false"> OK </v-btn>
                    <v-btn block @click="
                      dateMenu = false;
                    searchDate = [];
                    ">
                      Clear
                    </v-btn>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-5 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">
                    Unit
                  </div>
                  <v-text-field v-model="input.searchBranch" label="Cari Lokasi" dense solo flat outlined clearable>
                  </v-text-field>
                  <span>Selected:
                    {{
                      input.branch.name ? input.branch.name : "unit belum dipilih"
                    }}
                    <v-icon v-show="input.branch.id" @click="
                      input.branch = {};
                    active = [];
                    ">mdi-close</v-icon>
                  </span>
                  <div v-show="!input.branch.id" style="overflow-y: scroll; height: 300px">
                    <v-treeview activatable :active="active" :items="tempOptionsBranch"
                      @update:active="treeClick"></v-treeview>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">
                    Nama SPKLU
                  </div>
                  <v-autocomplete v-model="input.spklu" :items="optionsSpklu" label="Semua SPKLU" dense solo flat
                    outlined item-text="name" item-value="id" return-object :color="colorActive"
                    :search-input.sync="searchSpkluKeyword" :loading="awaitingSearch" clearable>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small depressed color="#999999" text @click="dialogFilter = false">
              Kembali
            </v-btn>
            <v-btn small depressed :color="colorActive" @click="
              dialogFilter = false;
            reGetData();
            " dark>
              Cari
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import SpkluService from "@/services/default/SpkluService";
import RefService from "@/services/default/RefService";
import BarChart from "@/components/chart";
import { StorageService } from "@/services/storage.service";

const spkluService = SpkluService.build();
const refService = RefService.build();
export default {
  name: "spklu-lokasi-spklu",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    BarChart,
  },
  data: () => ({
    dateMenu: false,
    isLoading: false,
    searchDate: [],
    colorActive: "#2671D9",
    colorInactive: "#9A9A9A",
    dateEvseConvert: "",
    dateSPKLUConvert: "",
    currentyear: "",
    currentMonth: "",
    cardItems: {
      hijau: 0,
      kuning: 0,
      merah: 0,
      biru: 0,
    },
    headersSPKLU: [
      { value: "unit", text: "UNITUPI", align: "right" },
      { value: "nama", text: "UID/UIW" },
      { value: "total", text: "AKUMULASI SAAT INI", align: "right" },
      {
        value: "jumlahTahun",
        text: "PENAMBAHAN TAHUN 2024",
        align: "right",
      },
      { value: "jumlahBulan", text: "PENAMBAHAN Maret 2024", align: "right" },
    ],
    headers: [
      { value: "idSpklu", text: "ID_SPKLU", align: "left" },
      { value: "chargeboxId", text: "CHARGEBOX_ID", align: "left" },
      { value: "namaSpklu", text: "NAMA_SPKLU", align: "left" },
      { value: "alamatSpklu", text: "ALAMAT_SPKLU", align: "left" },
      { value: "dayaSpklu", text: "DAYA_SPKLU", align: "left" },
      { value: "namaupi", text: "UIW/UID", align: "left" },
      { value: "namaup", text: "UP3", align: "left" },
      { value: "namaap", text: "ULP", align: "left" },
      { value: "provinsi", text: "PROV", align: "left" },
      { value: "pemda", text: "KOTA/KAB", align: "left" },
      { value: "latitude", text: "LATITUDE", align: "left" },
      { value: "longitude", text: "LONGITUDE", align: "left" },
      { value: "namaChargebox", text: "NAMA_CHARGEBOX", align: "left" },
      { value: "jmlChargerSpklu", text: "JML_CHARGER_SPKLU", align: "left" },
      { value: "jmlConnectorSpklu", text: "JML_CONNECTOR_SPKLU", align: "left" },
      // { value: "connectorId", text: "CONNECTOR_ID", align: "left" },
      { value: "jmlConnectorCharger", text: "JML_CONNECTOR_CHARGER", align: "left", },
      { value: "tglOperasiSpklu", text: "TGL_OPERASI_SPKLU", align: "left" },
      { value: "tglOperasiEvse", text: "TGL_OPERASI_EVSE", align: "left" },
    ],
    items: [],
    itemsRekap: [],
    itemsPerPageDetail: 10,
    pagination: {
      numberOfElements: 0,
      currentPage: 0,
      totalElements: 0,
      totalPages: 0,
    },
    dataRekapIntegrasi: [],
    search: "",
    sortSettings: "",
    isFetching: false, // for datatable
    locationMarkerList: [],
    chartData: [],

    // map properties
    zoom: 5,
    center: latLng(-2.372369, 115.421875),
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: true,
      boxZoom: false,
      keyboard: false,
      dragging: true,
    },
    showMap: false,
    isShowPage: false,
    mapObj: {},
    table_title: "",
    timer: "",
    // dialog properties
    dialog: false,
    dialogTitle: "",
    chargeBoxList: [],
    showTooltip: false,
    // client side pagination properties
    page: 1,
    pageRekap: 1,
    pageRekapCount: 0,
    pageCount: 0,
    itemsPerPage: 10,

    // filter
    input: {
      jml_transaksi: {},
      branch: {},
      spklu: {},
      searchBranch: "",
      is_active: {},
    },
    dialogFilter: false,
    optionsJmlTransaksi: [
      { id: "hijau", name: "Jumlah Transaksi" },
      { id: "kuning", name: "Akumulasi kWh" },
      { id: "merah", name: "Total Rp" },
      // { id: "biru", name: "SPKLU Non PLN" },
    ],
    optionsAvailability: [
      { id: "active", name: "Available" },
      { id: "inactive", name: "Unavailable" },
    ],
    optionsSpklu: [],
    optionsLokasi: [],
    optionsBranch: [],
    tempOptionsBranch: [],
    searchSpkluKeyword: "",
    awaitingSearch: false,
    active: [],
    itemsExcel: [],
    param: {},
    currentDates: "",
  }),

  async created() {
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    const endDate = `${year}-${month}-${day}`;

    // Get the date for last month
    const lastMonthDate = new Date(currentDate);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

    const lastMonthYear = lastMonthDate.getFullYear();
    const lastMonthMonth = String(lastMonthDate.getMonth() + 1).padStart(
      2,
      "0"
    );
    const lastMonthDay = String(lastMonthDate.getDate()).padStart(2, "0");

    const startDate = `${lastMonthYear}-${lastMonthMonth}-${lastMonthDay}`;

    this.param = Object.assign({
      startDate: startDate,
      endDate: endDate,
    });
    this.getDataDetailIntegrasi({
      startDate: this.param.startDate,
      endDate: this.param.endDate,
      page: 0,
      size: this.itemsPerPageDetail,
    });
    this.table_title = "Detail Integrasi SPKLU";
    this.isShowPage = true;
    this.showMap = true;
    this.getSpkluData(this.param);
    this.getSpkluCard(this.param);
    this.getBranchList();
  },

  computed: {
    dateDisp() {
      return this.searchDate.join(" ~ ");
      // format/do something with date
    },
  },

  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata();
    const newVal = this.input.branch.id;
    const oldVal = responseAuth.branch.idBranch;

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    const datesCurrent = `${day}-${month}-${year}`;

    this.currentDates = datesCurrent;

    const start = `${year}-${month}-01`;
    const end = `${year}-${month}-${day}`;

    if (newVal === undefined) {
      this.searchDate.push(start, end);
      this.param.startDate = this.searchDate[0];
      this.param.endDate = this.searchDate[1];

      if (responseAuth.branch.name !== "PUSAT") {
        this.input.branch.id = responseAuth.branch.idBranch;
        this.input.branch.name = responseAuth.branch.name;
      }

      this.getDataDetailIntegrasi({
        startDate: this.param.startDate,
        endDate: this.param.endDate,
        page: this.pagination.currentPage,
        size: this.itemsPerPageDetail,
      });
      await this.getOptionsSpklu(oldVal);
      await this.reGetData();

    }
  },

  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer);
  },

  watch: {
    async itemsPerPageDetail(newValue) {
      this.isLoading = true
      await this.getDataDetailIntegrasi({
        startDate: this.param.startDate,
        endDate: this.param.endDate,
        page: 0,
        size: newValue,
      })
      this.isLoading = false
    },

    "input.branch": function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.getOptionsSpklu(newVal.id);
      }
    },

    "input.searchBranch": function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch;
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val);
      }
    },

  },

  methods: {
    async downloadExcel() {
      const param = {
        name: "Integrasi SPKLU " + this.currentDates + ".xlsx",
        startDate: this.searchDate[0],
        endDate: this.searchDate[1],
        q: this.input.branch?.id,
      };

      await spkluService.getDilSpkluExcell(param);
    },

    allowedDates: function (val) {
      var today = new Date();
      var year = today.getFullYear();
      var month = (today.getMonth() + 1).toString().padStart(2, "0");
      var day = today.getDate().toString().padStart(2, "0");
      var currentDate = `${year}-${month}-${day}`;

      return val <= currentDate;
    },

    // handle pagination
    processPagination(res) {
      this.isLoading = true
      const data = res.data?.data?.content
      const paginationData = res.data.data
      this.items = data
      this.pagination = {
        numberOfElements: paginationData.numberOfElements,
        currentPage: paginationData.number + 1,
        totalElements: paginationData.totalElements,
        totalPages: paginationData.totalPages,
      }
      if (!paginationData.last) {
        this.itemsPerPageDetail = this.pagination.numberOfElements
      }

      this.isLoading = false
    },

    async getDataDetailIntegrasi(param) {
      this.isLoading = true;
      try {
        const response = await spkluService.getDilSpklu(param);
        this.processPagination(response)
      } catch (e) {
        console.log('Failed to get data Detail Integrasi: ', e);
        throw e
      } finally {
        this.isLoading = false
      }
    },

    async fetchPage() {
      this.isLoading = true;
      try {
        this.getDataDetailIntegrasi({
          startDate: this.param.startDate,
          endDate: this.param.endDate,
          page: this.pagination.currentPage - 1,
          size: this.itemsPerPageDetail,
        })
      } catch (e) {
        throw e
      } finally {
        this.isLoading = false
      }
    },

    goToNext() { },
    goToPrev() { },

    async getSpkluData(param) {
      this.isFetching = true;
      const responseRekap = await spkluService.getRekapIntegrasiSpklu(param);
      const dataRekap = responseRekap.data.data;
      this.locationMarkerList = [];

      this.itemsRekap = dataRekap;

      const monthNames = [
        "JANUARI",
        "FEBRUARI",
        "MARET",
        "APRIL",
        "MEI",
        "JUNI",
        "JULI",
        "AGUSTUS",
        "SEPTEMBER",
        "OKTOBER",
        "NOVEMBER",
        "DESEMBER",
      ];

      const currentMonthIndex = new Date().getMonth();

      this.currentyear = new Date().getFullYear();
      this.currentMonth = monthNames[currentMonthIndex];

      this.headersSPKLU = [
        { value: "unit", text: "UNITUPI", align: "right" },
        { value: "nama", text: "UID/UIW" },
        { value: "total", text: "AKUMULASI SAAT INI", align: "right" },
        {
          value: "jumlahTahun",
          text: `PENAMBAHAN TAHUN ${this.currentyear}`,
          align: "right",
        },
        {
          value: "jumlahBulan",
          text: `PENAMBAHAN ${this.currentMonth} ${this.currentyear}`,
          align: "right",
        },
      ];
      this.isFetching = false;
    },


    async openDialog(marker) {
      await this.getSpkluAvailability(marker.id);
      this.dialogTitle = marker.nama;
      this.dialog = true;
    },
    async getSpkluAvailability(id) {
      const param = {
        idSpklu: id,
      };
      const response = await spkluService.getDetailAvailabilitySpklu(param);
      const {
        data: { data },
      } = response;
      this.chargeBoxList = data;
    },
    iconSelector(data) {
      if (data.kategori !== "PLN") {
        return "/maps/ic-spklu-blue.svg";
      } else if (data.jml_transaksi > 50) {
        return "/maps/ic-spklu-green.svg";
      } else if (data.jml_transaksi >= 11 && data.jml_transaksi <= 50) {
        return "/maps/ic-spklu-yellow.svg";
      } else if (data.jml_transaksi <= 10) {
        return "/maps/ic-spklu-red.svg";
      }
    },
    async getSpkluCard(param) {
      const response = await spkluService.getDetailTransaktionCard(param);
      const {
        data: {
          data: { kwh, rp, transaksi },
        },
      } = response;
      this.cardItems = {
        hijau: kwh,
        kuning: rp,
        merah: transaksi,
      };
    },

    async exportExcel() {
      document.getElementById("d").click();
    },
    openDialogFilter() {
      this.dialogFilter = true;
    },

    async getBranchList() {
      const branch = JSON.parse(localStorage.getItem("branch_list"))?.data;
      if (branch) {
        this.optionsBranch = branch;
        this.tempOptionsBranch = branch;
      } else {
        const param = {
          companyId: 1,
          branchId: "",
        };
        const response = await refService.getBranchList(param);
        const {
          data: { data },
        } = response;

        const temp = data.map((item) => {
          // remap level 1
          item.child = item.child.map((item2) => {
            // remap level 2
            item2.child = item2.child.map((item3) => {
              // remap level 3
              item3.child = item3.child.map((item4) => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split("").join(".") + " - " + item4.name,
                  children: item4.child,
                };
              });
              return {
                id: item3.id,
                name: item3.id.split("").join(".") + " - " + item3.name,
                children: item3.child,
              };
            });
            return {
              id: item2.id,
              name: item2.id.split("").join(".") + " - " + item2.name,
              children: item2.child,
            };
          });
          return {
            id: item.id,
            name: item.id.split("").join(".") + " - " + item.name,
            children: item.child,
          };
        });

        this.optionsBranch = temp;
        this.tempOptionsBranch = temp;

        localStorage.setItem(
          "branch_list",
          JSON.stringify({
            data: temp,
          })
        );
      }
    },
    treeClick(value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem("branch_list"))?.data;
        this.input.branch = this.findComplex(branch, value[0]);
      }
    },
    async getOptionsSpklu(id) {
      this.paging.page = 0;
      this.paging.size = 999;

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging);
      const response = await refService.getSpkluList(param);
      const { data } = response;
      if (data.success !== true) return;

      if (this.input.branch.id !== param.q || param.q === undefined) {
        this.optionsSpklu = [];
      } else {
        this.optionsSpklu = data.data.content.map((data) => {
          return {
            id: data.idSpklu,
            name: data.spkluName,
          };
        });
      }
    },
    async reGetData() {
      let q = "";

      if (this.input.spklu && this.input.spklu.id) {
        q = this.input.spklu.id;
      } else if (this.input.branch && this.input.branch.id) {
        q = this.input.branch.id;
      }

      const isActive = this.input.is_active ? this.input.is_active.id : "";

      const param = Object.assign({
        card: this.input.jml_transaksi ? this.input.jml_transaksi.id : "",
        q: q,
        isActive: isActive,
      });
      if (this.searchDate.length > 1) {
        param.startDate = this.searchDate[0];
        param.endDate = this.searchDate[1];
      } else if (this.searchDate.length === 1) {
        param.startDate = this.searchDate[0];
        param.endDate = this.searchDate[0];
      }


      await this.getDataDetailIntegrasi(param);
      await this.getSpkluData(param);
      await this.getSpkluCard(param);
    },
  },
};
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* Hitam transparan */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #707070 94%, #0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%, #707070);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: l13 1s infinite linear;
}

@keyframes l13 {
  100% {
    transform: rotate(1turn)
  }
}

.summary-alert-title {
  font-weight: 400;
  font-size: 22px;
  color: #f9f9f9;
}

.summary-alert-value {
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
}

.summary-alert-title-black {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.summary-alert-value-black {
  font-weight: 600;
  font-size: 24px;
  color: #000000;
}

.search {
  height: 48px;
}

.leaflet-popup-close-button {
  color: none;
}

.leaflet-container {
  font-family: "Inter";
}

.popup-property {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #9a9a9a;
}

.popup-value {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.popup-table tr td {
  padding: 5px;
}

.v-dialog__content--active {
  z-index: 224 !important;
}

.vue2leaflet-map {
  z-index: 200 !important;
}

.red-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/red-box.svg");
  /* background: linear-gradient(259deg, #FF5E5E 52.44%, #FF9898 100%); */
}

.yellow-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/yellow-box.svg");
  /* background: linear-gradient(255deg, #F3AF00 51.62%, #FFE39A 100%); */
}

.green-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/green-box.svg");
  /* background: linear-gradient(257deg, #5BBA2E 53.55%, #AAE190 100%); */
}

.white-xcards {
  border-radius: 8px;
  background-size: cover;
  background-image: url("/box/white-box.svg");
  /* background: linear-gradient(261deg, #D9D9D9 50%, #F5F5F5 100%); */
}

.xcards {
  border-radius: 8px;
  background-size: cover;
  background-color: rgb(96, 204, 219);
  border-color: rgb(96, 204, 219);
}
</style>
